import { useTranslation } from "react-i18next";

const PriceLabel = ({ product, showCurrency = false, onInfoClick }) => {
  const { t } = useTranslation();

  if (product.price > 0) {
    const price = Number(product.price).toFixed(2);

    return showCurrency ? `${price} €` : price;
  }

  return (
    <button
      className="font-medium underline cursor-pointer"
      type="button"
      onClick={onInfoClick}
    >
      {t("Info")}
    </button>
  );
};

export default PriceLabel;
